(() => {
  if (customElements.get('dm-moopilot-demo')) return;

  class DairyMindMooPilotDemo extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('[data-moopilot-item]')];
      this.initial = this.querySelector('[data-moopilot-initial]');
      this.user = this.querySelector('[data-moopilot-user]');
      this.answer = this.querySelector('[data-moopilot-answer]');
      this.typing = this.querySelector('[data-moopilot-typing]');
      this.conversation = this.querySelector('[data-moopilot-conversation]');
      this.onClick = (event) => {
        const button = event.target.closest('[data-moopilot-question]');
        const item = button?.closest('[data-moopilot-item]');
        if (this.items.includes(item)) this.selectQuestion(item, false);
      };
      this.onBlockSelect = (event) => {
        const item = this.items.find((entry) =>
          entry.dataset.moopilotItem === event.detail?.blockId || entry.contains(event.target)
        );
        if (item) this.selectQuestion(item, true);
      };
      this.addEventListener('click', this.onClick);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      clearTimeout(this.replyTimer);
      this.removeEventListener('click', this.onClick);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    selectQuestion(item, immediate) {
      const content = item.querySelector('[data-moopilot-content]')?.content;
      if (!content) return;
      clearTimeout(this.replyTimer);
      const question = content.querySelector('[data-question]').textContent;
      const answer = content.querySelector('[data-answer]').textContent;
      this.items.forEach((entry) => {
        entry.querySelector('button')?.setAttribute('aria-pressed', String(entry === item));
      });
      this.initial.hidden = true;
      this.user.textContent = question;
      this.user.hidden = false;
      this.answer.textContent = '';
      this.answer.hidden = true;
      this.typing.hidden = immediate;
      this.conversation.setAttribute('aria-busy', String(!immediate));
      const showAnswer = () => {
        this.typing.hidden = true;
        this.answer.textContent = answer;
        this.answer.hidden = !answer.trim();
        this.conversation.setAttribute('aria-busy', 'false');
      };
      if (immediate) showAnswer();
      else this.replyTimer = setTimeout(showAnswer, 550);
    }
  }

  customElements.define('dm-moopilot-demo', DairyMindMooPilotDemo);
})();

